/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "user-324f2d18--sprite",
  "use": "user-324f2d18--sprite-usage",
  "viewBox": "0 0 38 38",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 38 38\" id=\"user-324f2d18--sprite\">\n    <defs>\n        <clipPath id=\"user-324f2d18--sprite_clip-path\">\n            <circle id=\"user-324f2d18--sprite_Ellipse_610\" data-name=\"Ellipse 610\" cx=\"19\" cy=\"19\" r=\"19\" transform=\"translate(-22491.881 -6891)\" fill=\"currentColor\" stroke=\"currentColor\" stroke-width=\"1\" />\n        </clipPath>\n    </defs>\n    <g id=\"user-324f2d18--sprite_Group_16560\" data-name=\"Group 16560\" transform=\"translate(22491.881 6891)\">\n        <g id=\"user-324f2d18--sprite_Mask_Group_122\" data-name=\"Mask Group 122\" clip-path=\"url(#user-324f2d18--sprite_clip-path)\">\n            <g id=\"user-324f2d18--sprite_Group_11763\" data-name=\"Group 11763\" transform=\"translate(-22604.979 -7014.823)\">\n                <circle id=\"user-324f2d18--sprite_Ellipse_616\" data-name=\"Ellipse 616\" cx=\"7.111\" cy=\"7.111\" r=\"7.111\" transform=\"translate(124.274 144.942) rotate(-83.117)\" fill=\"currentColor\" />\n                <path id=\"user-324f2d18--sprite_Path_4410\" data-name=\"Path 4410\" d=\"M141.489,161.624h-18.6a3.865,3.865,0,0,1-3.635-5.251,13.965,13.965,0,0,1,25.868,0A3.866,3.866,0,0,1,141.489,161.624Z\" fill=\"currentColor\" />\n            </g>\n        </g>\n    </g>\n</symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
